// 与后端 HUA_DA 公众号配置一致，不受其他页面缓存的 publicType 影响。
const appId = "wxb0ea01d4fd25cc75";

export function buildChangGanNaoOAuthUrl(query = {}) {
  const params = Object.keys(query)
    .filter((key) => key !== "code" && key !== "state" && query[key] != null)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
    .join("&");
  const redirectUri = `https://yisheng.healthmore.net/changGanNaoInfo${params ? "?" + params : ""}`;
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
}
